import { render, staticRenderFns } from "./ListBannedWowStreamers.vue?vue&type=template&id=8422ea6e&scoped=true"
import script from "./ListBannedWowStreamers.vue?vue&type=script&lang=js"
export * from "./ListBannedWowStreamers.vue?vue&type=script&lang=js"
import style0 from "./ListBannedWowStreamers.vue?vue&type=style&index=0&id=8422ea6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8422ea6e",
  null
  
)

export default component.exports